module.exports = __webpack_public_path__ + "static/img/036 1.988d5622.jpg";